import React, { useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { Label } from 'reactstrap';
import './TauriSearchResultDetailModal.css';
import setting from '../../config.json';
import { useEffect } from 'react';
import TauriHostContainer from '../TauriHostContainer/TauriHostContainer';
import { AccessComponentFactory } from '../../visualizations/AccessComponentFactory';
import TauriImage from '../TauriImage/TauriImage';
import TauriIdentifierDropdown from '../TauriBreadcrumbs/TauriBreadcrumbDropdown/TauriIdentifierDropdown/TauriIdentifierDropdown';
import TauriMonthAndYearDropdown from '../TauriBreadcrumbs/TauriBreadcrumbDropdown/TauriMonthAndYearDropdown/TauriMonthAndYearDropdown';
import TauriConfigTypeCodeDropdown from '../TauriBreadcrumbs/TauriBreadcrumbDropdown/TauriConfigTypeCodeDropdown/TauriConfigTypeCodeDropdown';
import config from '../../config.json';
import { useFilterContext } from '../TauriGlobalContext/TauriGlobalContext';

const TauriSearchResultDetailModal = ({ show, onHide, item, style }) => {
    const getPermission = localStorage.getItem('permission');
    const decodedPermission = JSON.parse(atob(getPermission));
    const access = decodedPermission?.DataScope?.Access;

    const [isMaximized, setIsMaximized] = useState(false);
    const modalContentRef = useRef(null);
    const [itemSections, setItemSections] = useState([]);
    const [chartPalettes, setChartPalettes] = useState([]);
    const [chartThemes, setChartThemes] = useState([]);
    const [applicationItems, setApplicationItems] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedApp, setSelectedApp] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [userAccessDetails, setUserAccessDetails] = useState([]);
    const [accessType, setAccessType] = useState(null);
    const [empCode, setEmpCode] = useState('');
    const configtype = localStorage.getItem('ConfigTypeCode');

    const { updateFilterValue } = useFilterContext();
    const [codenameKey, setCodenameKey] = useState('');
    const [selectedCode, setSelectedCode] = useState('');
    const [selectedConfigTypeCode, setSelectedConfigTypeCode] = useState('');
    const [loginEmployeeCode, setloginEmployeeCode] = useState(localStorage.getItem('EmployeeCode') || '');
    const [selectedDates, setSelectedDates] = useState(() => ({
        FromMonth: null,
        FromYear: null,
        ToMonth: null,
        ToYear: null,
    }));

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const ACCESS_TYPE_MAP = {
        customers: { type: "customers", key: "CustomerCode", value: 8 },
        agents: { type: "agents", key: "AgentCode", value: 1 },
        districts: { type: "districts", key: "DistrictManagerCode", value: 2 },
        territories: { type: "territories", key: "AgentCode", value: 0 },
        distributors: { type: "distributors", key: "DistributorCode", value: 3 },
        regions: { type: "regions", key: "RegionCode", value: 4 },
        items: { type: "items", key: "ItemCode", value: 10 },
        customergroups: { type: "c-groups", key: "CustomerGroup", value: 0 },
        itemgroups: { type: "p-groups", key: "ItemGroupCode", value: 9 }
    };

    useEffect(() => {
        if (show && item) {
            const url = new URL(item.access_path, window.location.origin);
            const pathParts = url.pathname.split('/').filter(Boolean);
            const accesstype = pathParts[pathParts.length - 1];

            const accessDetails = Object.values(ACCESS_TYPE_MAP).find(item => item.type === accesstype);
            const data = item?.identifier?.split(',').map(part => part?.trim());

            const accessCode = accessDetails?.value === ACCESS_TYPE_MAP.agents.value ? data.map(entry => entry.split('|')[1]) : data;
            const empC = accessDetails?.value === ACCESS_TYPE_MAP.agents.value ? data[0]?.split('|')[0] : '';

            setAccessType(accessDetails?.value || -1);
            setEmpCode(empC);
            setUserAccessDetails(accessCode || []);

            setSelectedType(accessDetails.value);

            fetchSectionItems(accessDetails?.value || '');
            setSelectedConfigTypeCode(configtype?.split(',')[0]?.toString())
        } else if (!show) {
            // Optionally reset the values if modal is closed
            setAccessType(null);
            setUserAccessDetails([]);
        }
    }, [show, item]);


    useEffect(() => {
        fetchAppList();
    }, [selectedApp, selectedType]);

    useEffect(() => {
        // Cleanup function to clear localStorage when modal is closed
        if (!show) {
            localStorage.removeItem('code');
            localStorage.removeItem('accesscode');
        }
    }, [show]);

    useEffect(() => {
        updateFilterValue({
            FromMonth: selectedDates.FromMonth?.toString(),
            FromYear: selectedDates.FromYear?.toString(),
            ToMonth: selectedDates.ToMonth?.toString(),
            ToYear: selectedDates.ToYear?.toString(),
            [codenameKey]: selectedCode,
            ConfigTypeCode: selectedConfigTypeCode.toString(),
            EmployeeCode: loginEmployeeCode?.toString()
        });

    }, [selectedDates, selectedConfigTypeCode, selectedCode]);

    const fetchAppList = async () => {
        if (selectedApp) {
            try {
                const data = await AccessComponentFactory(selectedApp.id.toString(), selectedType.toString(), access);
                const colorsheme = await AccessComponentFactory('colorScheme', selectedType.toString());
                setItemSections(data.sections);
                setChartPalettes(colorsheme.palettes);
                setChartThemes(colorsheme.themes);
            } catch (error) {
                console.error("Failed to fetch export list", error);
            }
        }
    };

    const fetchSectionItems = async (type) => {
        const applicationData = await AccessComponentFactory('applicationdashboard', type.toString());
        setApplicationItems(applicationData.applications);

        if (applicationData.applications.length > 0 && !selectedApp) {
            setSelectedApp(applicationData.applications[0]);
        }
    };

    const handleMaximizeClick = () => {
        setIsMaximized(true);
    };

    const handleRestoreClick = () => {
        setIsMaximized(false);
    };

    const handleSelectedIdentifier = (key, value) => {
        setSelectedCode(value);
        setCodenameKey(key);
    };

    const handleDateChange = (dateValue) => {
        setSelectedDates(dateValue);
    };

    const handleConfigTypeCodeChange = (configtype) => {
        setSelectedConfigTypeCode(configtype)
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`searchresult-modal-visual ${isMaximized ? 'maximized' : ''} resizable`}
            style={style}
            centered>
            <Modal.Header className="searchresult-modal-header">
                <div className="d-flex flex-column w-100">
                    <div className="d-flex">
                        <div className="chart-title">
                            <Label className="label_code">
                                (
                                {
                                    userAccessDetails?.toString()
                                }
                                )
                            </Label>
                            <Label className="label_name">{item?.header || ''}</Label>
                        </div>
                        <div className="ms-auto d-flex">
                            {isMaximized ? (
                                <Button className='button-minimize align-items-center d-none d-xl-flex' variant='light' onClick={handleRestoreClick}>
                                    <img src={process.env.PUBLIC_URL + "/Images/arrow-minimize.svg"} alt="Icon" />
                                </Button>
                            ) : (
                                <Button className='button-maximize align-items-center d-none d-xl-flex' variant='light' onClick={handleMaximizeClick}>
                                    <img src={process.env.PUBLIC_URL + "/Images/arrow-maximize.svg"} alt="Icon" />
                                </Button>
                            )}
                            <Button className='button-close' variant='light' onClick={onHide}>
                                <img src={process.env.PUBLIC_URL + "/Images/material-symbols--close.svg"} alt="Icon" />
                            </Button>
                        </div>
                    </div>
                    <div className='filter-section d-flex flex-column flex-lg-row'>
                        <div className='section-view'>
                            <Label>View :</Label>
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <Dropdown.Toggle caret>
                                    {selectedApp ? selectedApp.name : 'Select Dashboard'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='dropdown-menu dropdown-menu-end'>
                                    {applicationItems.map((app) => (
                                        <Dropdown.Item
                                            key={app.id}
                                            onClick={() => setSelectedApp(app)}
                                        >
                                            {app.name}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className='section-date'>
                            {
                                (userAccessDetails && accessType) &&
                                <div className='tauri-filter d-flex align-items-center'>
                                    <TauriMonthAndYearDropdown onDateChange={handleDateChange} />
                                    <TauriIdentifierDropdown AccessRange={empCode} AccessCodes={userAccessDetails} AccessLevel={accessType} handleSelected={handleSelectedIdentifier} />
                                    <TauriConfigTypeCodeDropdown ConfigCode={configtype} handleSelected={handleConfigTypeCodeChange} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body
                ref={modalContentRef}
                className="searchresult-modal-body" style={{
                    height: `${setting.hostSectionHeight}rem`,
                }}>
                {
                    (userAccessDetails && accessType) &&
                    <TauriHostContainer itemSection={itemSections} chartPalette={chartPalettes} chartTheme={chartThemes} />
                }
            </Modal.Body>
            <Modal.Footer className='searchresult-modal-footer'>
            </Modal.Footer>
        </Modal>
    );
};

export default TauriSearchResultDetailModal;
